export default "__VITE_ASSET__GL7SD$HO__"